import { literal, preprocess } from 'zod';

import { requiresActivationConstraintWithLimitsSchema } from '@occc/feat-constraints/schemas';

import { BaseEarnSchema } from './base-earn.schema';

import { AwardCountWithoutTransactionSchema } from '../award-count.schema';
import { AwardPointsPerVariantSchema } from '../award.schema';
import { BaseOfferConfigurationSchema } from '../base-offer.schema';
import { OfferType } from '../../types';

export const BaseEarnOfferSchema = BaseOfferConfigurationSchema.extend({
  offerType: literal(OfferType.BaseEarn),
  baseEarn: preprocess((data) => data ?? {}, BaseEarnSchema),
  awardCount: AwardCountWithoutTransactionSchema,
  activation: requiresActivationConstraintWithLimitsSchema,
}).merge(AwardPointsPerVariantSchema);
